<template>
  <el-dialog 
  :visible.sync="visible"
  :append-to-body="true"
  custom-class="basic-info-satellite"
  :title="$t('DataSubmission.BasicInformation')" >
  <div class="dialog-content">
    <div class="data-content">
      <div class="info-col-div"><span class="basic-info-satellite-names">{{ $t('satellite.dataidentifier') }}:</span>&emsp;{{currentSatellite.fileName}}</div>
    </div>
    <div class="data-content">
      <div class="info-col-div"><span class="basic-info-satellite-names">{{ $t('satellite.Satellite') }}:</span>&emsp;{{currentSatellite.batch}}</div>
      <div class="info-col-div"><span class="basic-info-satellite-names">{{ $t('DataSubmission.sensor') }}:</span>&emsp;{{currentSatellite.sensor}}</div>
      <div class="info-col-div"><span class="basic-info-satellite-names">{{ $t('Order.Shootingtime') }}:</span>&emsp;{{currentSatellite.stoptime}}</div>
    </div>
    <div class="data-content">
      <div class="info-col-div"><span class="basic-info-satellite-names">{{ $t('satellite.Upperleftlatitudeandlongitude') }}:</span>&emsp;{{Number(currentSatellite.sdriW).toFixed(5)+' / ' + Number(currentSatellite.sdriN).toFixed(5)}}</div>
      
      <div class="info-col-div"><span class="basic-info-satellite-names">{{ $t('satellite.Upperrightlatitudeandlongitude') }}:</span>&emsp;{{Number(currentSatellite.sdriE).toFixed(5)+' / ' + Number(currentSatellite.sdriN).toFixed(5)}}</div>
      <div class="info-col-div"></div>
    </div>
    <div class="data-content">
      <div class="info-col-div"><span class="basic-info-satellite-names">{{ $t('satellite.Lowerleftlatitudeandlongitude') }}:</span>&emsp;{{Number(currentSatellite.sdriW).toFixed(5)+' / ' + Number(currentSatellite.sdriS).toFixed(5)}}</div>
      
      <div class="info-col-div"><span class="basic-info-satellite-names">{{ $t('satellite.Latitudeandlongitudeinlowerrightcorner') }}:</span>&emsp;{{Number(currentSatellite.sdriE).toFixed(5)+' / ' + Number(currentSatellite.sdriS).toFixed(5)}}</div>
      <div class="info-col-div"></div>
    </div>
    <div class="data-content">
      <div class="info-col-div">
      <el-image style="width: 300px;height: 300px" :src="currentSatellite.mediaUrl">
        <div slot="error" class="image-slot center">
          {{ $t('satellite.Nothumbnail') }}
        </div>
      </el-image>

      </div>
      <div class="info-col-div" v-if="visible">
      <div class="infoMap" id="infoMaps" style="width:500px;height:300px"></div>
      </div>
    </div>
  </div>
  </el-dialog>
</template>

<script>
import L from 'leaflet';
import {tiledMapLayer} from '@supermap/iclient-leaflet';
import 'leaflet-draw'
export default {
  data(){
    return{
      visible: false,
      mapView:{},
      productDataInfo: {},
      AreaGroup:null,
      currentSatellite:{
        FileName:'',
        mediaUrl:'',
        Batch:'',
        Sensor:'',
        stoptime:'',
        location_shape:{
          coordinates:[
            [[[],[],[],[],[]]]
          ]
        }
      }
    }
  },
  mounted(){
    
  },
  created(){
    console.log('详情');
  },
  computed:{

  },
  components: {
  },
  watch:{
    visible(val){
      if(val){
        this.$nextTick( () =>{
          this.initBaseMap()
        })
      }
    }
  },
  methods:{
    addAllArea(arrs){
      let a = []
      arrs.forEach(element => {
        a.push([parseFloat(element[1]),parseFloat(element[0])])
      });
      a.splice(a.length-1,1)
      var polygon = L.polygon(a, {color: 'red'});
      this.AreaGroup.addLayer(polygon)
      this.mapBaseViewDetail.fitBounds(polygon.getBounds());
    },
    openIt(val){
      this.currentSatellite = val
      this.visible = true
    },
    initBaseMap(){
        this.mapBaseViewDetail = L.map('infoMaps', {
          rs: L.CRS.EPSG3857,
          center: [50,50],
          zoom: 1
        });
        tiledMapLayer('http://139.198.12.108:8090/iserver/services/map-bingmap/rest/maps/Aerial',{noWrap:true}).addTo(this.mapBaseViewDetail);
        this.AreaGroup = L.layerGroup().addTo(this.mapBaseViewDetail);
        this.addAllArea(this.currentSatellite.location_shape.coordinates[0])
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content{
  display: flex;
  flex-direction: column;

  .data-content{
    display: flex;
    margin-bottom: 20px;
    flex-direction: row;
    justify-content: space-around;
    .info-col-div{
      flex: 1;
    }
  }
}
/deep/ .image-slot{
  width: 100%;
  height: 100%;
  background: white;
  color: #c0c4cc;
}
/deep/ .basic-info-satellite .el-dialog__header{
  padding: 12px 30px !important;
  span{
    color: white;
    font-size: 15px;
  }
  .el-dialog__headerbtn{
    margin-top: -5px;
    i{
      color: white;
    }
  }
}
</style>

<style lang="scss">
.basic-info-satellite .el-dialog__body{
    @include sitellite_bg_v4_color();
    .basic-info-satellite-name{
      @include co_white_to_black();
    }
}
</style>